// extracted by mini-css-extract-plugin
export var afterEmail = "mailForm-module--afterEmail--0f6cf";
export var afterName = "mailForm-module--afterName--2cada";
export var afterSubmit = "mailForm-module--afterSubmit--1d5d2";
export var email = "mailForm-module--email--6d11b";
export var error = "mailForm-module--error--194c5";
export var formContainer = "mailForm-module--formContainer--478f4";
export var headerText = "mailForm-module--headerText--4c703";
export var mailForm = "mailForm-module--mailForm--15894";
export var mailform = "mailForm-module--mailform--dff77";
export var name = "mailForm-module--name--2c678";
export var submit = "mailForm-module--submit--28347";
export var success = "mailForm-module--success--094e4";